import { clientEnv } from '../config/env';

function trimTrailingSlash(url) {
  return String(url || '').replace(/\/+$/, '');
}

/** 钱包 DApp 深链接目标站点（来自 VUE_APP_DEEPLINK_BASE_URL） */
export function getDeeplinkBaseUrl() {
  return trimTrailingSlash(clientEnv.deeplinkBaseUrl);
}

/**
 * 构建 /walletPay/tgNo/{no}/referralCode/{code} 完整 URL
 * @param {string|number} tgNo 订单号或 tg 号
 * @param {string} referralCode 推荐码
 * @param {{ encoded?: boolean }} options encoded=true 时对路径段做 encodeURIComponent
 */
export function buildWalletPayUrl(tgNo, referralCode, { encoded = false } = {}) {
  const base = getDeeplinkBaseUrl();
  const no = encoded ? encodeURIComponent(tgNo ?? '') : String(tgNo ?? '');
  const code = encoded ? encodeURIComponent(referralCode ?? '') : String(referralCode ?? '');
  return `${base}/walletPay/tgNo/${no}/referralCode/${code}`;
}
